const getFirstStringFromObject = (obj) => {
  if (!obj || typeof obj !== "object") {
    return "";
  }

  const values = Object.values(obj);
  for (let index = 0; index < values.length; index += 1) {
    const value = values[index];
    if (typeof value === "string" && value.trim() !== "") {
      return value;
    }
    if (
      Array.isArray(value) &&
      value.length > 0 &&
      typeof value[0] === "string"
    ) {
      return value[0];
    }
  }

  return "";
};

export const getApiErrorMessage = (error) => {
  const fallbackMessage = "Something went wrong";
  const offlineMessage = "Please Check internet";

  if (!error) {
    return fallbackMessage;
  }

  const responseData =
    (error.response && error.response.data) || error.data || {};

  const errorMessage =
    typeof error.message === "string" && error.message.trim() !== ""
      ? error.message
      : "";

  const looksLikeNetworkError =
    /network error|failed to fetch|network request failed|load failed/i.test(
      errorMessage,
    ) ||
    (typeof navigator !== "undefined" && navigator.onLine === false);

  if (looksLikeNetworkError) {
    return offlineMessage;
  }

  if (typeof responseData === "string" && responseData.trim() !== "") {
    return responseData;
  }

  const directMessage =
    responseData.message || responseData.error || responseData.detail;

  if (typeof directMessage === "string" && directMessage.trim() !== "") {
    return directMessage;
  }

  if (Array.isArray(responseData.errors) && responseData.errors.length > 0) {
    const firstError = responseData.errors[0];
    if (typeof firstError === "string" && firstError.trim() !== "") {
      return firstError;
    }
  }

  const nestedDataMessage = getFirstStringFromObject(responseData.data);
  if (nestedDataMessage) {
    return nestedDataMessage;
  }

  return errorMessage || fallbackMessage;
};
